module.exports = __webpack_public_path__ + "img/twitter.93073a20.svg";